import { signal } from "@preact/signals";
import { errorMessage } from "../api/client";

export type ToastKind = "info" | "success" | "error";

export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
}

const MAX_TOASTS = 4;
let nextId = 1;

export const toasts = signal<Toast[]>([]);

export function dismissToast(id: number): void {
  toasts.value = toasts.value.filter((t) => t.id !== id);
}

/** Show a toast. `ms` of 0 keeps it until dismissed. Returns the toast id. */
export function toast(message: string, kind: ToastKind = "info", ms = 4000): number {
  const id = nextId++;
  const next = [...toasts.value, { id, kind, message }];
  toasts.value = next.length > MAX_TOASTS ? next.slice(next.length - MAX_TOASTS) : next;
  if (ms > 0) setTimeout(() => dismissToast(id), ms);
  return id;
}

export function toastError(e: unknown): number {
  return toast(errorMessage(e), "error", 6000);
}
